import { Box } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import styles from './GlobalBannerStyles';
import './GlobalBannerComponent.scss';
import parse from 'html-react-parser';

const GlobalBannerComponent = ({
  bannerProps
}) => {
  const bannerStyles = styles;
  const selectedBanner = bannerStyles[bannerProps.bannerType];

  // display nothing if empty or false.
  if (!bannerProps.bannerType || !selectedBanner) {
    return null;
  }

  function getBannerSpacing(){
    if(bannerProps.bannerAction!==undefined && bannerProps.bannerAction?.text !== undefined && bannerProps.toggleBanner === undefined ){
      return 'global-banner-without-toggle';
    } else if (bannerProps.bannerAction!==undefined && bannerProps.bannerAction?.text !== undefined && bannerProps.toggleBanner !== undefined) {
      return 'global-banner-content';
    } else if (bannerProps.bannerAction===undefined && bannerProps.bannerTitle !== undefined && bannerProps.bannerMessage === undefined) {
      return 'global-banner-only-title';
    }
    return 'global-banner-content-without-action';
  }

  let containerClass = bannerProps.restrictUser ? 'restrict-user-container' : 'global-banner-container';

  if (window.location.href.includes('add-user')) {
    containerClass += ' add-user-banner';
  }
  return ( 
    <Box className={containerClass}> 
      <Box
        className='global-banner'
        style={{ backgroundColor: selectedBanner.backgroundColor }}>
        <Box className={getBannerSpacing()}>
          <img className='global-banner-icon' src={selectedBanner.icon} alt='banner' />
          <Box className='global-banner-copy'>
            {bannerProps.bannerTitle && (
              <Box className='global-banner-title'>{parse(bannerProps.bannerTitle)}</Box>
            )}
            {bannerProps.bannerMessage && (
              <Box className='global-banner-message'>{parse(bannerProps.bannerMessage)}</Box>
            )}
            {bannerProps.bannerSubtext && (
              <Box className='global-banner-subtext'>
                {parse(bannerProps.bannerSubtext)}
              </Box>
            )}          
          </Box>
          {bannerProps.bannerAction!==undefined && bannerProps.bannerAction.text !== undefined && (
            <Box className='global-banner-link' style={{ color: selectedBanner.linkColor }} onClick={bannerProps.bannerAction.action}>
              {parse(bannerProps.bannerAction.text)}
            </Box>
          )}
          {bannerProps.toggleBanner !== undefined && ( 
          <CloseIcon className='close-global-banner' onClick={bannerProps.toggleBanner}/>)}
        </Box>
      </Box>
    </Box>
  );
};

export default GlobalBannerComponent;
